import client from "services/ngage/api-client";
import DataPage from "types/DataPage";
import {Achievement, AchievementData} from "types/Achievement";
import deserializeAchievement from "services/ngage/deserializers/achievement";
import {snakeKeys} from "../array";
import DataResource from "../../types/DataResource";

export type AchievementFilters = {
  page?: number
  perPage?: number
  types?: 'quiz-complete' | 'trail-complete'
  order?: string
}

/**
 * Get all achievements (paginated)
 */
const all = async (page: number = 1) => {
  const response = await client.get<DataPage<Achievement>>(`/achievements?page=${page}`)

  if(response.data){
    response.data.data = response.data.data.map(deserializeAchievement)
  }

  return response.data;
}

/**
 * Get all achievements (paginated)
 */
const filtered = async (filters: AchievementFilters = {}) => {
  const params = Object.assign({page: 1, per_page: 100}, snakeKeys(filters))
  const response = await client.get<DataResource<Achievement>>('/achievements', {params})

  if (response.data) {
    response.data.data = response.data.data.map(deserializeAchievement)
  }

  return response.data
}

/**
 * Get a single achievement
 *
 * @param {number} id
 */
const get = async (id: number) => {
  const response = await client.get<Achievement>(`/achievements/${id}`)
  return response.data? deserializeAchievement(response.data) : null
}

/**
 * Store a new achievement
 *
 * @param data
 */
const store = async (data: AchievementData) => {
  const response = await client.post<Achievement>('/achievements', data)
  return response.data? deserializeAchievement(response.data) : null
}

/**
 * Update an existing achievement
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: AchievementData) => {
  const response = await client.put<Achievement>(`/achievements/${id}`, data)
  return response.data? deserializeAchievement(response.data) : null
}

/**
 * Permanently delete an achievement
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
  const response = await client.delete<null>(`/achievements/${id}`)
  return response.status === 204
}

const achievements = {
  all,
  filtered,
  get,
  store,
  update,
  destroy
}

export default achievements;